import React, { useState, useEffect, useMemo } from 'react';
import {
  Backdrop,
  Box,
  Button,
  Modal,
  Fade,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import BuzzAutoCompleteSingleSelectInput from '../../../components/BuzzAutoCompleteInput/BuzzAutoCompleteSingleSelectInput';
import { useDispatch, useSelector } from 'react-redux';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import usePlanOptions from '../usePlanOptions';
import { getAllBuzzSubscriptions } from '../BuzzSlice';

function LicenseUploadModal({ show, handleCloseModal, handleUpload }) {
  const dispatch = useDispatch();
  const { ecosystems: userTypeOptions } = usePlanOptions();

  const { subscriptions, akademySchools, buzzOneSchools } = useSelector(
    ({ akademyReducer, buzz, buzzOne }) => {
      return {
        subscriptions: buzz.subscriptions,
        akademySchools: akademyReducer.schools,
        buzzOneSchools: buzzOne.schools,
      };
    }
  );

  const [ecosystem, setEcosystem] = useState(null);
  const [schoolId, setSchoolId] = useState(null);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [file, setFile] = React.useState(null);

  const schools = useMemo(() => {
    if (ecosystem === 'BUZZ_ONE') return buzzOneSchools;
    else if (ecosystem === 'AKADEMY') return akademySchools;
    else return [];
  }, [ecosystem]);

  useEffect(() => {
    if (!schoolId) return;

    dispatch(getAllBuzzSubscriptions({ ecosystem, schoolId }));
  }, [schoolId]);

  const handleUploadDocument = (e) => {
    if (e.target.files.length) {
      setFile(e.target.files[0]);
    }
  };

  return (
    <Modal
      open={show}
      onClose={handleCloseModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Fade in={show}>
        <Box
          sx={{
            minHeight: 220,
            width: 500,
            bgcolor: 'white',
            px: 2,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            py: 2,
            borderRadius: '8px',
          }}>
          <Box>
            <Box display="flex" justifyContent={'space-between'}>
              <Box fontFamily={'Rubik'} fontSize={18} fontWeight={500} mb={2}>
                Bulk Consume Licenses
              </Box>
              <Box sx={{ cursor: 'pointer' }}>
                <CloseIcon fontSize="medium" onClick={handleCloseModal} />
              </Box>
            </Box>

            <Box mt={2}>
              <Box
                p={2}
                display={'flex'}
                flexDirection={'column'}
                justifyContent={'space-around'}
                style={{ gap: '1rem' }}>
                {' '}
                <BuzzSelect
                  // fullWidth={false}
                  name="Ecosystem"
                  size={'small'}
                  value={ecosystem}
                  onChange={(e) => {
                    setEcosystem(e.target.value);
                  }}
                  label="Select Ecosystem"
                  options={userTypeOptions}
                  required={true}
                />
                <BuzzAutoCompleteSingleSelectInput
                  id={'school'}
                  label={'School'}
                  options={schools.map(({ _id, name }) => {
                    return { label: name, value: _id };
                  })}
                  value={schoolId}
                  onChange={(value) => {
                    setSchoolId(value);
                  }}
                  required={true}
                />
                <BuzzAutoCompleteSingleSelectInput
                  id={'school'}
                  label={'Subscription'}
                  options={subscriptions
                    .filter(({ plan }) => plan)
                    .map(({ _id, plan }) => {
                      return {
                        label: plan.name,
                        value: _id,
                      };
                    })}
                  value={subscriptionId}
                  onChange={(value) => {
                    setSubscriptionId(value);
                  }}
                  required={true}
                />
              </Box>

              <Typography style={{ fontSize: 14 }}>
                <ol>
                  <li>
                    Download the{' '}
                    <a
                      href="/buzz_bulk_license_template.csv"
                      download="bulk_license_template.csv">
                      template
                    </a>
                    .{' '}
                  </li>
                  <li>Start adding rows without removing the header.</li>
                  <li>Upload the file </li>
                </ol>
              </Typography>
              <Box mt={2} px={3}>
                <input
                  accept=".csv"
                  id="upload-license-csv"
                  type="file"
                  onChange={handleUploadDocument}
                />
                <Typography style={{ fontSize: 12 }}>
                  Upload a .csv file (max size 2mb)
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box display={'flex'} justifyContent="flex-end" mt={3}>
            <Box mr={2}>
              <Button
                variant="outlined"
                color="primary"
                onClick={handleCloseModal}>
                Cancel
              </Button>
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleUpload(file, subscriptionId)}
              disabled={file === null}>
              Upload File & Consume License
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
}

export default LicenseUploadModal;
